import React from "react";
import { useSearchParams } from "react-router-dom";
import { RecordsTable } from "dyl-components";
import CallHistoryLogHeader from "./Header";
import CallHistoryRow from "./Row";
import PropTypes from "prop-types";
import "./index.scss";

const CallHistoryLogTable = ({
    isColumnHidden,
    onPageChange,
    onEditLog,
    onAddContact,
    onMarkVoicemail,
    onReportCall,
    isTimelineTab,
    onFilter,
    count,
    isLoading,
    data,
    contactAccountOptions,
    isReadingContacts,
    root,
}) => {
    const [params] = useSearchParams();

    return (
        <RecordsTable
            tableBodyClassName="CallHistoryTable"
            isTableLoading={isLoading}
            isSearchResultEmpty={
                !count && (params.get("search") || params?.get("phone"))
            }
            isTableEmpty={
                !count && !(params.get("search") || params?.get("phone"))
            }
            TableHeader={
                <CallHistoryLogHeader
                    isColumnHidden={isColumnHidden}
                    isTimelineTab={isTimelineTab}
                    onFilter={onFilter}
                    root={root}
                    contactAccountOptions={contactAccountOptions}
                    isReadingContacts={isReadingContacts}
                />
            }
            TableRows={data?.map?.((call) => (
                <CallHistoryRow
                    key={call?.call_uuid}
                    entry={call}
                    isColumnHidden={isColumnHidden}
                    onEditLog={onEditLog}
                    onAddContact={onAddContact}
                    onMarkVoicemail={onMarkVoicemail}
                    onReportCall={onReportCall}
                    isTimelineTab={isTimelineTab}
                    root={root}
                />
            ))}
            recordsCount={count}
            activePage={params.get("page")}
            onPageChange={onPageChange}
            recordsName="Call History Logs"
            emptySubtitle=" "
            emptyListTitle="No Calls to display"
            hasPagination={count > 0}
        />
    );
};

CallHistoryLogTable.defaultProps = {
    isColumnHidden: () => false,
    onPageChange: () => {},
};

CallHistoryLogTable.propTypes = {
    isColumnHidden: PropTypes.func,
    onPageChange: PropTypes.func,
    isTimelineTab: PropTypes.bool,
    onFilter: PropTypes.func,
    count: PropTypes.number,
    isLoading: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.object),
    contactAccountOptions: PropTypes.array,
    isReadingContacts: PropTypes.bool,
    root: PropTypes.string,
};

export default CallHistoryLogTable;
